import Image from '../../../components/AppImage';
import { Link } from 'react-router-dom';
import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
	return (
		<section className='relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 via-white to-gray-100'>
			{/* Enhanced Background Pattern */}
			<div className='absolute inset-0 opacity-10'>
				<div className='absolute top-0 left-0 w-full h-full bg-gradient-to-r from-[#800020]/15 via-transparent to-[#DB954E]/15'></div>
				<div className='absolute top-20 right-10 w-40 h-40 bg-[#800020]/8 rounded-full blur-3xl'></div>
				<div className='absolute bottom-20 left-10 w-48 h-48 bg-[#DB954E]/8 rounded-full blur-3xl'></div>
				<div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-[#800020]/5 to-[#DB954E]/5 rounded-full blur-3xl'></div>
			</div>

			{/* Decorative Elements */}
			<div className='absolute top-10 left-10 w-2 h-20 bg-[#800020] opacity-30'></div>
			<div className='absolute bottom-10 right-10 w-2 h-20 bg-[#DB954E] opacity-30'></div>

			<div className='relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20'>
				<div className='grid lg:grid-cols-2 gap-16 items-center'>
					{/* Content Section */}
					<motion.div
						initial={{ opacity: 0, x: -50 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8 }}
						className='space-y-8'
					>
						{/* Welcome Text */}
						<div>
							<h2 className='font-source font-light text-lg text-gray-600 mb-4 uppercase tracking-wider'>
								Welcome to
							</h2>
							<h1 className='font-playfair font-bold text-5xl md:text-6xl lg:text-7xl text-[#800020] mb-8 leading-tight'>
								FEPA LAW PARTNERS
							</h1>
						</div>

						{/* Main Content */}
						<div className='space-y-6'>
							<p className='font-source text-lg text-gray-700 leading-relaxed'>
								We are an experienced team of attorneys and solicitors with proven record of
								diligence to proffer productive legal advice with cost effective approach to meet
								the needs of our clients. We timeously deliver our professional services to clients
								without missing out on necessary details. Our goal is to protect our clients by
								managing the possible risks and effectively resolving them
							</p>

							<p className='font-source text-lg text-gray-700 leading-relaxed'>
								Our practice areas include Commercial Law & Debt Recovery, Intellectual Property
								Law, Energy and Natural Resources Law, Property Law Practice, Family Law, Medical
								Law, Corporate Law, Labour/Industrial and Employment Law, Litigation & Alternative
								Dispute Resolution (ADR), International Investment Law, Tax law, Corporate
								Governance, Environmental law, International investment Arbitration, Criminal Law,
								Banking and finance law, Foreign Investment and Corporate Law etc.
							</p>
						</div>

						{/* Call to Action */}
						<div className='pt-8'>
							<div className='flex flex-col sm:flex-row gap-4'>
								<motion.a
									href='tel:+2349095529557'
									whileHover={{ scale: 1.05 }}
									whileTap={{ scale: 0.95 }}
									className='inline-flex items-center justify-center px-8 py-4 bg-[#800020] text-white font-source font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300'
								>
									<span>Call Now: (+234) 909-552-9557</span>
								</motion.a>
								<motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
									<Link
										to='/contact'
										className='inline-flex items-center justify-center px-8 py-4 border-2 border-[#800020] text-[#800020] font-source font-bold rounded-xl hover:bg-[#800020] hover:text-white transition-all duration-300'
									>
										<span>Schedule a Consultation</span>
									</Link>
								</motion.div>
							</div>
						</div>
					</motion.div>

					{/* Partners Image Section */}
					<motion.div
						initial={{ opacity: 0, x: 50 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8, delay: 0.2 }}
						className='relative'
					>
						<div className='relative w-full h-[500px] rounded-3xl overflow-hidden shadow-2xl border-4 border-white'>
							<Image
								src='https://cyaeqqikswnokglgkfev.supabase.co/storage/v1/object/public/images/all-lawyers.jpg'
								alt='Fepa Law Partners - Professional Legal Team'
								className='w-full h-full object-cover object-center'
							/>
							<div className='absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent'></div>

							{/* Professional Badge */}
							<div className='absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm rounded-xl p-3 shadow-lg'>
								<div className='flex items-center space-x-2'>
									<div className='w-10 h-10 bg-[#800020] rounded-lg flex items-center justify-center'>
										<span className='font-playfair font-bold text-lg text-white'>F</span>
									</div>
									<div>
										<p className='font-source font-bold text-base text-gray-800'>
											Fepa Law Partners
										</p>
										<p className='font-source text-xs text-gray-600'>Excellence in Advocacy</p>
									</div>
								</div>
							</div>
						</div>

						{/* Enhanced Decorative Elements */}
						<div className='absolute -bottom-10 -left-10 w-40 h-40 bg-[#DB954E]/20 rounded-full blur-3xl'></div>
						<div className='absolute -top-10 -right-10 w-32 h-32 bg-[#800020]/20 rounded-full blur-2xl'></div>
						<div className='absolute top-1/2 -right-5 w-10 h-10 bg-[#800020] rounded-full opacity-60'></div>
						<div className='absolute bottom-1/2 -left-5 w-8 h-8 bg-[#DB954E] rounded-full opacity-60'></div>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default HeroSection;
